import React, { useState } from "react"; //
import Modal from "@mui/material/Modal";
import { makeStyles } from '@mui/styles'; // מייבא מהחבילה החדשה
import Typography from "@mui/material/Typography";
import Button from "../../base/reusables/button/Button";
import { useTranslation } from "react-i18next";
import style from "./MultModal.module.css";

interface MultModalPropsDI {
  text: string;
  isOpen?: boolean;
  handleModalStatus?: (errorMode: boolean) => void;
  firstFunc: () => void;
  secondFunc: () => void;
  firstFuncText: string;
  secondFuncText: string;
}

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme: any) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    position: "absolute",
    paddingTop: "77px",
    height: "254px",
    width: "512px",
    outline: "none",
    backgroundColor: "rgba(255, 255, 255, 1)",
    borderRadius: "13px 13px 0 0",
    boxShadow: "0 25px 31px 0 rgba(0, 0, 0, 0.2)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderBottomLeftRadius: "50% 40px !important",
    borderBottomRightRadius: "50% 40px !important",
    "@media (max-width: 600px)": {
      width: "80vw",
    },
  },
  modalBackdrop: {
    backgroundColor: "rgba(0, 15, 30, 0.81)",
    "& div:first-child": {
      backgroundColor: "unset !important",
    },
  },
  title: {
    textAlign: "center",
    fontFamily: "FbReforma-Medium",
    fontSize: "25px",
    color: "rgba(40, 40, 40, 1)",
    letterSpacing: "0px",
    marginBottom: "41px",
    "@media (max-width: 600px)": {
      fontSize: "16px",
    },
  },
  buttonWrapper: {
    display: "flex",
  },
}));

const MultModal: React.FC<MultModalPropsDI> = (props) => {
  const [modalOpen, setModalOpen] = useState(true);

  const classes = useStyles();

  const handleOpenStatus = () => {
    props.secondFunc();
  };

  const handleFirstFunc = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.stopPropagation();
    props.firstFunc();
  };

  const handleSecondFunc = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.stopPropagation();
    props.secondFunc();
  };

  // const {t} = useTranslation();

  return (
    <Modal
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      open={props.isOpen !== undefined ? props.isOpen : modalOpen}
      onClose={handleOpenStatus}
      className={classes.modalBackdrop}
      BackdropProps={{
        classes: {
          root: classes.modalBackdrop,
        },
      }}
      // hideBackdrop={true}
    >
      <div style={getModalStyle()} className={classes.paper}>
        <Typography variant="h6" id="modal-title" className={classes.title}>
          {props.text}
        </Typography>
        <div className={style.buttonWrapper}>
          <Button
            aria-label={props.firstFuncText}
            onClick={(e) => handleFirstFunc(e)}
            variant="filled"
          >
            {props.firstFuncText}
          </Button>
          <Button
            aria-label={props.secondFuncText}
            onClick={(e) => handleSecondFunc(e)}
            variant="empty"
          >
            {props.secondFuncText}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

// export default observer(LessonForm);
export default MultModal;
